"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropdownMultipleValues = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable @typescript-eslint/no-explicit-any */
const app_1 = require("app");
const React = require("react");
const react_select_1 = require("react-select");
const LoadingSpinner_1 = require("../LoadingSpinner/LoadingSpinner");
const DropdownValue_1 = require("./components/DropdownValue");
const DropdownOption_1 = require("./components/DropdownOption");
const MosaicIcon_1 = require("Views/Shared/Components/MosaicIcon");
class DropdownMultipleValues extends React.Component {
    constructor(props) {
        super(props);
        this.selectMinWidth = 220;
        this.getTransformedOptions = (filter, makeIsLoadingFalse = true) => {
            const dropdownLabel = filter.placeholder || filter.title;
            const unselectOption = {
                value: '',
                label: dropdownLabel,
            };
            const options = [unselectOption];
            filter.items.forEach(option => {
                if (option.label.indexOf('@') === -1) {
                    if (makeIsLoadingFalse) {
                        option.isLoading = false;
                    }
                    options.push(option);
                }
            });
            return options;
        };
        this.getSubGroups = () => {
            const { filter } = this.props;
            const subGroups = {};
            if (filter.items.length > 0) {
                filter.items.forEach((item, itemIndex) => {
                    const subFilters = item.label.split('@');
                    if (subFilters.length > 1) {
                        if (!subGroups[subFilters[0]]) {
                            subGroups[subFilters[0]] = [];
                        }
                        subGroups[subFilters[0]].push(Object.assign(Object.assign({}, filter.items[itemIndex]), { label: subFilters[1] }));
                    }
                });
            }
            return subGroups;
        };
        this.getSubOptions = subGroups => {
            const { filter } = this.props;
            const subGroupItems = [];
            Object.keys(subGroups).forEach(subGroup => {
                if (!filter.items
                    .map(item => ({
                    label: item.label,
                    selected: item.selected,
                }))
                    .filter(item => Object.keys(subGroups).indexOf(item.label) > -1 && item.selected)
                    .filter(item => item.label === subGroup)[0]) {
                    return;
                }
                const options = [];
                subGroups[subGroup].forEach(item => {
                    options.push(item);
                });
                subGroupItems.push({
                    label: subGroup,
                    options,
                });
            });
            return [{ label: this.props.approvalType, value: '' }, ...subGroupItems];
        };
        this.renderDropdownOption = option => {
            return (0, jsx_runtime_1.jsx)(DropdownOption_1.default, { option: option });
        };
        this.renderDropdownIndicator = props => {
            return ((0, jsx_runtime_1.jsxs)(react_select_1.components.DropdownIndicator, Object.assign({}, props, { children: [(0, jsx_runtime_1.jsx)(MosaicIcon_1.MosaicIcon, { name: "expand-more", className: "icon icon-chevron-down-small w-[24px] h-[24px] text-icon-primary" }), (0, jsx_runtime_1.jsx)(MosaicIcon_1.MosaicIcon, { name: "expand-less", className: "icon icon-chevron-up-small w-[24px] h-[24px] text-icon-primary" })] })));
        };
        this.renderLoadingIndicator = props => {
            return ((0, jsx_runtime_1.jsx)(react_select_1.components.IndicatorsContainer, Object.assign({}, props, { children: (0, jsx_runtime_1.jsx)(LoadingSpinner_1.default, { visible: true }) })));
        };
        this.renderDropdownValue = props => ((0, jsx_runtime_1.jsx)(DropdownValue_1.DropdownValue, Object.assign({}, props, { selectedCount: this.getSelectedValuesCount(), isLoading: this.state.isLoading })));
        this.renderDropdownValueSub = props => ((0, jsx_runtime_1.jsx)(DropdownValue_1.DropdownValue, Object.assign({}, props, { selectedCount: this.getSelectedSubValuesCount(), isLoading: this.state.isLoading })));
        this.updateSelectedValue = (isSub = false) => (newSelectedValues, actionMeta) => {
            const { selectedValues } = this.props;
            const isNewValueSelected = newSelectedValues.length > selectedValues.length;
            const theLastOption = (actionMeta === null || actionMeta === void 0 ? void 0 : actionMeta.option) || newSelectedValues[newSelectedValues.length - 1];
            const isResetOptionSelected = (theLastOption === null || theLastOption === void 0 ? void 0 : theLastOption.value) === '';
            if (isResetOptionSelected && selectedValues.length === 0) {
                return;
            }
            this.setState({ selectedOption: theLastOption }, () => {
                this.makeLoadersVisible();
            });
            if (!isNewValueSelected) {
                this.unselectOption(newSelectedValues);
                return;
            }
            if (isResetOptionSelected) {
                this.unselectAllOption(theLastOption, isSub);
            }
            else {
                this.selectAllOption(theLastOption);
            }
        };
        this.makeLoadersVisible = () => {
            const { setIsResultsLoading, filter } = this.props;
            const { selectedOption, theLastRequest } = this.state;
            if (!this.isTheLastOptionResultLoaded(theLastRequest, filter.items)) {
                this.setState({ isLoading: true });
                setIsResultsLoading && setIsResultsLoading(true);
                this.setState(prevState => {
                    const updatedOptions = this.state.options.map(option => option.label === (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.label)
                        ? Object.assign(Object.assign({}, option), { isLoading: true, isDisabled: true }) : option);
                    return Object.assign(Object.assign({}, prevState), { options: updatedOptions });
                });
            }
        };
        this.selectAllOption = (theLastOption) => {
            this.setState({
                theLastRequest: { value: theLastOption.value, selected: true },
            });
            this.props.onFilterChange(this.props.groupValue, theLastOption.value);
        };
        this.unselectAllOption = (theLastOption, isSub) => {
            this.setState({
                theLastRequest: { value: '', selected: true },
            });
            this.props.onFilterChange(this.props.groupValue, theLastOption.value, true, isSub);
        };
        this.unselectOption = (newSelectedValues) => {
            const newSelectedValuesMap = newSelectedValues.reduce((acc, curr) => {
                acc[curr.value] = true;
                return acc;
            }, {});
            const removedOption = this.props.selectedValues.filter(value => !newSelectedValuesMap[value])[0];
            this.setState({
                theLastRequest: { value: removedOption, selected: false },
            });
            this.props.onFilterChange(this.props.groupValue, removedOption);
        };
        this.getSelectedOptionsFromValues = (options, selectedValues) => {
            if (options.length === 0) {
                return [];
            }
            const selectedOptions = [];
            options
                .filter(option => selectedValues.indexOf(option.value) !== -1)
                .forEach(option => selectedOptions.push(option));
            if (options.filter(item => item.options).length > 0) {
                options.forEach(group => {
                    if (group.options) {
                        group.options
                            .filter(option => selectedValues.indexOf(option.value) !== -1)
                            .forEach(option => selectedOptions.push(option));
                    }
                });
            }
            return selectedOptions;
        };
        this.isTheLastOptionResultLoaded = (option, items) => {
            switch (option.value) {
                case null:
                    return false;
                    break;
                case '':
                    return items.every(item => item.selected === false);
                    break;
                default:
                    return items.some(item => item.value === option.value && item.selected === option.selected);
                    break;
            }
        };
        this.selectSizeRef = React.createRef();
        this.state = {
            selectWidth: null,
            options: [],
            isLoading: false,
            theLastRequest: {
                value: null,
                selected: false,
            },
            selectedOption: null,
        };
    }
    componentDidMount() {
        const selectWidth = this.getSelectWidth();
        const { filter } = this.props;
        const options = this.getTransformedOptions(filter);
        this.setState({
            selectWidth,
            options,
            isLoading: false,
            selectedOption: null,
            theLastRequest: {
                value: null,
                selected: false,
            },
        });
    }
    componentDidUpdate(prevProps) {
        const { filter, setIsResultsLoading } = this.props;
        const { theLastRequest, isLoading } = this.state;
        if (this.isTheLastOptionResultLoaded(theLastRequest, filter.items)) {
            const transformedOptions = this.getTransformedOptions(filter);
            this.setState({
                options: transformedOptions,
                isLoading: false,
                theLastRequest: { value: null, selected: false },
                selectedOption: null,
            });
            setIsResultsLoading && setIsResultsLoading(false);
            return;
        }
        if (!isLoading && !app_1.UtilService.isArraysAreEqual(prevProps.filter.items, filter.items)) {
            const transformedOptions = this.getTransformedOptions(filter, false);
            this.setState({
                options: transformedOptions,
            });
        }
    }
    render() {
        const { options, selectWidth, isLoading } = this.state;
        const { filter, selectedValues, isDocumentsZeroResults, className = '', onOpen = () => null, onClose = () => null, groupValue, } = this.props;
        const subGroups = this.getSubGroups();
        const isDisabled = isDocumentsZeroResults || filter.isDisabled || filter.items.length === 0;
        const dropdownLabel = filter.placeholder || filter.title;
        const selectedOptions = this.getSelectedOptionsFromValues(options, selectedValues);
        const customStyles = {
            control: provided => (Object.assign(Object.assign({}, provided), { width: this.state.selectWidth })),
            groupHeading: provided => (Object.assign(Object.assign({}, provided), { fontSize: 16, fontWeight: 400, color: 'black', textTransform: 'capitalize' })),
        };
        const selectClassNames = `dropdown-multiple-values 
      ${className}
      ${selectedOptions.length && !isLoading ? 'has-selected-value' : ''}`;
        const selectSubClassNames = `dropdown-multiple-values ${className} ${selectedOptions.filter(item => item.label.indexOf('@') > -1).length > 0
            ? 'has-selected-value'
            : ''}`;
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("div", { className: "dropdown-multiple-values-wrapper inline-block relative h-11", "data-filter-id": groupValue, children: [selectWidth && ((0, jsx_runtime_1.jsx)(react_select_1.default, { backspaceRemovesValue: false, className: selectClassNames, classNamePrefix: "dropdown-multi-values", closeMenuOnSelect: false, blurInputOnSelect: false, components: {
                                IndicatorSeparator: () => null,
                                DropdownIndicator: this.renderDropdownIndicator,
                                LoadingIndicator: this.renderLoadingIndicator,
                                Option: this.renderDropdownOption,
                                MultiValue: this.renderDropdownValue,
                            }, hideSelectedOptions: false, isClearable: false, isDisabled: isDisabled, isLoading: isLoading, isMulti: true, isSearchable: false, options: options, onMenuOpen: onOpen, onMenuClose: onClose, onChange: this.updateSelectedValue(), placeholder: dropdownLabel, "aria-label": dropdownLabel, screenReaderStatus: () => '', styles: customStyles, value: selectedOptions || '', tabSelectsValue: false })), (0, jsx_runtime_1.jsxs)("div", { className: "select-size-detector", ref: this.selectSizeRef, children: [dropdownLabel, " (99)"] })] }), Object.keys(subGroups).length > 0 &&
                    filter.items
                        .map(item => ({
                        label: item.label,
                        selected: item.selected,
                    }))
                        .filter(item => Object.keys(subGroups).indexOf(item.label) > -1 && item.selected)
                        .length > 0 && ((0, jsx_runtime_1.jsxs)("div", { className: "dropdown-multiple-values-wrapper inline-block relative h-11", children: [selectWidth && ((0, jsx_runtime_1.jsx)(react_select_1.default, { backspaceRemovesValue: false, className: selectSubClassNames, classNamePrefix: "dropdown-multi-values", closeMenuOnSelect: false, blurInputOnSelect: false, components: {
                                IndicatorSeparator: () => null,
                                DropdownIndicator: this.renderDropdownIndicator,
                                LoadingIndicator: this.renderLoadingIndicator,
                                Option: this.renderDropdownOption,
                                MultiValue: this.renderDropdownValueSub,
                            }, hideSelectedOptions: false, isClearable: false, isDisabled: isDisabled, isLoading: isLoading, isMulti: true, isSearchable: false, options: this.getSubOptions(subGroups), onMenuOpen: onOpen, onMenuClose: onClose, onChange: this.updateSelectedValue(true), placeholder: this.props.approvalType, "aria-label": this.props.approvalType, screenReaderStatus: () => '', styles: customStyles, value: selectedOptions || '', "aria-labelledby": dropdownLabel, tabSelectsValue: false })), (0, jsx_runtime_1.jsxs)("div", { className: "select-size-detector", ref: this.selectSizeRef, children: [this.props.approvalType, " (99)"] })] }))] }));
    }
    getSelectedValuesCount() {
        const { filter } = this.props;
        return filter.items.filter(item => item.label.indexOf('@') === -1 && item.selected && !item.isDisabled).length;
    }
    getSelectedSubValuesCount() {
        const { filter } = this.props;
        return filter.items.filter(item => item.label.indexOf('@') > -1 && item.selected && !item.isDisabled).length;
    }
    getSelectWidth() {
        const selectSizeDetectorWidth = this.selectSizeRef.current.offsetWidth;
        return selectSizeDetectorWidth > this.selectMinWidth
            ? selectSizeDetectorWidth
            : this.selectMinWidth;
    }
}
exports.DropdownMultipleValues = DropdownMultipleValues;
